var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGemini(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 26,
    viewBox: "0 0 32 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13237_40512)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.2815 7.10232L24.0631 4.32069L24.2485 3.14944C19.1796 -1.45968 11.122 -0.937058 6.55247 4.23994C5.28335 5.67782 4.34172 7.47044 3.8396 9.32157L4.83585 9.18119L10.399 8.26369L10.8285 7.82457C13.3031 5.10682 17.4872 4.74119 20.3445 7.05357L21.2815 7.10232Z",
    fill: "#EA4335"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.0256 9.23979C27.3863 6.8853 26.0736 4.76864 24.2485 3.14954L20.3445 7.05354C21.1581 7.71838 21.8101 8.55928 22.2514 9.51282C22.6927 10.4664 22.9117 11.5077 22.8919 12.5582V13.2512C24.8106 13.2512 26.3665 14.8068 26.3665 16.7257C26.3665 18.6447 24.8108 20.1613 22.8919 20.1613H15.933L15.2498 20.903V25.0705L15.933 25.7244H22.8918C27.883 25.7633 31.9609 21.7877 31.9998 16.7964C32.0114 15.3069 31.6547 13.8376 30.9613 12.5192C30.268 11.2008 29.2595 10.0743 28.0256 9.23979Z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.98371 25.7245H15.9328V20.1612H8.98371C8.4918 20.1611 8.00573 20.0546 7.55883 19.849L6.57296 20.1515L3.77183 22.9331L3.52783 23.8799C5.09871 25.066 7.01533 25.733 8.98371 25.7245Z",
    fill: "#34A853"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.98379 7.67822C3.99254 7.70785 -0.029586 11.7783 0.000163977 16.7697C0.00836056 18.1452 0.3304 19.5006 0.941745 20.7327C1.55309 21.9649 2.43761 23.0412 3.52791 23.8797L7.55891 19.849C5.81016 19.0587 5.03291 17.0007 5.82304 15.252C6.61316 13.5032 8.67129 12.726 10.4199 13.516C11.1905 13.8642 11.8076 14.4814 12.1558 15.252L16.1868 11.221C15.3407 10.1149 14.2503 9.21961 13.0007 8.60504C11.7511 7.99046 10.3763 7.67317 8.98379 7.67822Z",
    fill: "#FBBC05"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13237_40512"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 25.75,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGemini);
export default __webpack_public_path__ + "static/media/Gemini.6639b1c301c753f7318f34f23b1193ee.svg";
export { ForwardRef as ReactComponent };